<div
	class="root-body root-body-sidebar-slim"
	[ngClass]="{
		'root-body-sidebar-slim':
			configService.config.menuMode === 'sidebar' ||
			configService.config.menuMode === 'slim',
		'root-body-sidebar-static':
			configService.config.menuMode === 'sidebar' &&
			configService.config.sidebarStatic,
		'root-body-horizontal': configService.config.menuMode === 'horizontal'
	}"
>
	<div class="header-controls mb-3" [formGroup]="range">
        <mat-form-field>
            <mat-label>Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate formControlName="start" (dateChange)="onDateRangeChange()" placeholder="Start date">
                <input matEndDate formControlName="end"  (dateChange)="onDateRangeChange()" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

		<button
			[matMenuTriggerFor]="exportFileType"
			mat-flat-button
			color="primary"
		>
			Export
			<mat-icon matSuffix>download</mat-icon>
		</button>

		<mat-menu #exportFileType="matMenu">
			<button mat-menu-item (click)="exportReport(fileTypeOptions.Excel)">
				XLSX
			</button>
			<button mat-menu-item (click)="exportReport(fileTypeOptions.CSV)">
				CSV
			</button>
			<button mat-menu-item (click)="exportReport(fileTypeOptions.PDF)">
				PDF
			</button>
		</mat-menu>
	</div>

	<div class="mat-elevation-z8">
		<div *ngIf="loading" class="loading-container">
			<mat-spinner></mat-spinner>
			<p>Loading finance reports...</p>
		</div>

		<div *ngIf="!loading && isEmpty" class="empty-state-container">
			<div class="empty-state-content">
				<mat-icon class="empty-state-icon">receipt_long</mat-icon>
				<h3 class="empty-state-title">No Finance Reports Found</h3>
				<p class="empty-state-description">
					No finance reports are available for the selected date range. Try
					adjusting your date filter or check back later.
				</p>
			</div>
		</div>

		<table
			mat-table
			[dataSource]="dataSource"
			matSort
			(matSortChange)="onSortChange($event)"
			*ngIf="!loading && !isEmpty"
			[matSortDirection]="currentSortDirection"
		>
			<ng-container matColumnDef="timeDelivered">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="timeDelivered">
					Time Delivered
				</th>
				<td mat-cell *matCellDef="let element">{{ element.timeDelivered }}</td>
			</ng-container>

			<ng-container matColumnDef="orderId">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="orderId">
					Order ID
				</th>
				<td mat-cell *matCellDef="let element">{{ element.orderId }}</td>
			</ng-container>

			<ng-container matColumnDef="orderValue">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="orderValue">
					Order Value
				</th>
				<td mat-cell *matCellDef="let element">
					₱{{ element.orderValue | number : "1.2-2" }}
				</td>
			</ng-container>

			<ng-container matColumnDef="merchantFundedPromo">
				<th
					mat-header-cell
					*matHeaderCellDef
					mat-sort-header="merchantFundedPromo"
				>
					Merchant Funded Promo
				</th>
				<td mat-cell *matCellDef="let element">
					₱{{ element.merchantFundedPromo | number : "1.2-2" }}
				</td>
			</ng-container>

			<ng-container matColumnDef="commission">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="commission">
					Commission
				</th>
				<td mat-cell *matCellDef="let element">
					₱{{ element.commission | number : "1.2-2" }}
				</td>
			</ng-container>

			<ng-container matColumnDef="withholdingTax">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="withholdingTax">
					Withholding Tax
				</th>
				<td mat-cell *matCellDef="let element">
					₱{{ element.withholdingTax | number : "1.2-2" }}
				</td>
			</ng-container>

			<ng-container matColumnDef="deliveryFeeDiscount">
				<th
					mat-header-cell
					*matHeaderCellDef
					mat-sort-header="deliveryFeeDiscount"
				>
					Delivery Fee Discount
				</th>
				<td mat-cell *matCellDef="let element">
					₱{{ element.deliveryFeeDiscount | number : "1.2-2" }}
				</td>
			</ng-container>

			<ng-container matColumnDef="earnings">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="earnings">
					Earnings
				</th>
				<td mat-cell *matCellDef="let element">
					₱{{ element.earnings | number : "1.2-2" }}
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>

		<mat-paginator
			[length]="totalRecords"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="pageSizeOptions"
			(page)="onPageChange($event)"
			showFirstLastButtons
			*ngIf="!loading && !isEmpty"
		>
		</mat-paginator>
	</div>
</div>
